import { Logout } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { ConfirmationDialog } from 'src/components/dialog/ConfirmationDialog';
import useAuth from 'src/hooks/useAuth';

export default function ContactInfo() {
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        bgcolor: '#FF4842',
        p: 2,
        borderRadius: 12,
        borderTopRightRadius: 0,
        height: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Button
        onClick={() => setOpen(true)}
        endIcon={<Logout sx={{ transform: 'scaleX(-1)', color: '#fff' }} />}
        sx={{ color: '#fff' }}
      >
        خروج
      </Button>
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        title="آیا می خواهید خارج شوید ؟"
        action={() => logout()}
        actionTitle={'بله'}
        cancelTitle="خیر"
      />
    </Box>
  );
}
